import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, filter, first, map } from 'rxjs';
import { GetProject } from 'src/app/discrepancies/store/discrepancies.actions';
import { getProject } from 'src/app/discrepancies/store/discrepancies.reducer';
import { BLOCKED_PROJECT_STATUSES, GeneralStatus } from 'src/app/spa/models/spa-project.model';

export const ProjectNotInProcessGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean | UrlTree> | boolean => {
  const projectId = route.parent?.paramMap.get('id') ?? route.paramMap.get('id');
  if (!projectId) return true;

  const store = inject(Store);
  const router = inject(Router);

  store.dispatch(GetProject({ projectID: projectId }));

  return store.select(getProject).pipe(
    filter((project) => project?.id === projectId),
    first(),
    map((project) =>
      BLOCKED_PROJECT_STATUSES.includes(project.status as GeneralStatus) ? router.createUrlTree(['/spa/projects']) : true
    )
  );
};
